import React, { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import {
  handleErrorToast,
  sortProjects,
  DateRangePicker,
} from "../CustomFunctions";
import { saveAs } from "file-saver";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import "jspdf-autotable";
import {
  AddwithWhiteCircle,
  DropdownArrow,
  DocumentIcon,
  DownloadIcon,
  Filter,
  Office,
  CircularGrid,
  DeleteDustbin,
  Attachment,
} from "../AllSvg";

import { DocumentSection, RenderSelectField } from "../FormdataComponent";
import Select from "react-select";
import JSZip from "jszip";
import { use } from "react";
import CertificateFormat from "./CertificateFormat";
import { axiosInstance2 } from "../../config/axiosInstance";
import "./CertificateAccess.css";

/* Shared react-select styles, pulled out so no inline styles remain on JSX */
const caSelectStyles = {
  control: (provided) => ({
    ...provided,
    width: "100%",
    minHeight: "36px",
    borderRadius: "6px",
    border: "1px solid #d0d7de",
    color: "#1a1a2e",
    backgroundColor: "#f7f8fa",
    padding: "0px 4px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#4a4a4a",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "2px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#4a4a4a",
  }),
  input: (provided) => ({
    ...provided,
    color: "#4a4a4a",
  }),
};

const AddCertificationAccess = ({
  getcertification,
  siteSubCompanyList,
  toggleCompany,
}) => {
  const [show, setShow] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [structureList, setstructureList] = useState([]);
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleShow = () => {
    setShow(true);
    getStructure();
  };
  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData);
    setFileNames("");
    setErrors("");
    setShowMoreDetails(false);
  };

  function initialFormData() {
    return {
      company_name: "",
      service_type: "",
      project_short_name: "",
      project_full_name: "",
      structure_details: [],
      client: "",
      lane_type: "0",
      project: "",
      total_length_km: "",
      total_cost_cr: "",
      is_jv: false,
      lead_partner: "",
      sectors: "",
      project_cost: "",
      jv_partner: "",
      associate_partner: "",
      our_share_percent: "",
      our_length_share_km: "0",
      our_cost_share_cr: "0",
      our_share_4_6_lane_length: "0",
      our_share_2_lane_length: "0",
      start_date: null,
      end_date: null,
      remarks: "",
      documents: [{ document_name: "", document_file: "" }],
    };
  }

  const [formData, setFormData] = useState(initialFormData());
  const [projectbyId, setProjectbyID] = useState("null");

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const requiredFields = [
      "start_date",
    ];

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
      return acc;
    }, {});

    formData.documents.forEach((doc, index) => {
      if (!doc.document_name || doc.document_name.trim() === "") {
        newErrors[`document_name_${index}`] =
          `Document Name is required for document ${index + 1}`;
      }
      if (!doc.document_file) {
        newErrors[`document_file_${index}`] =
          `Document File is required for document ${index + 1}`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const getProject = async () => {
    setBuffering(true);
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.company_name}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (formData.company_name) {
      getProject();
    }
  }, [formData.company_name]);

  useEffect(() => {
    if (formData.project && projectbyId) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: projectbyId.project_short_name,
        project_full_name: projectbyId.project_name,
      }));
    }
  }, [formData.project, projectbyId]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      company_name: toggleCompany,
    }));
  }, [toggleCompany]);

  useEffect(() => {
    if (formData.project !== "" || formData.company_name) {
      setFormData((prevData) => ({
        ...initialFormData(),
        company_name: prevData.company_name,
        project: prevData.project,
      }));
    }
  }, [formData.project, formData.company_name]);

  useEffect(() => {
    if (formData.service_type) {
      setFormData((prev) => ({
        ...prev,
        sectors: "",
      }));
    }
  }, [formData.service_type]);

  useEffect(() => {
    if (formData.sectors || formData.service_type) {
      setFormData((prev) => ({
        ...prev,
        lane_type: "0",
      }));
    }
  }, [formData.sectors, formData.service_type]);

  useEffect(() => {
    if (formData.sectors || formData.service_type || formData.lane_type) {
      setFormData((prev) => ({
        ...prev,
        total_length_km: "",
        total_cost_cr: "",
        project_cost: "",
      }));
    }
  }, [formData.sectors, formData.service_type, formData.lane_type]);

  useEffect(() => {
    if (
      formData.sectors ||
      formData.service_type ||
      formData.lane_type ||
      formData.jv_partner ||
      formData.is_jv ||
      formData.associate_partner ||
      formData.lead_partner
    ) {
      setFormData((prev) => ({
        ...prev,
        our_share_percent: "",
        our_cost_share_cr: "",
        our_share_4_6_lane_length: "",
        our_share_2_lane_length: "",
        our_length_share_km: "",
      }));
    }
  }, [
    formData.sectors,
    formData.service_type,
    formData.lane_type,
    formData.is_jv,
    formData.jv_partner,
    formData.lead_partner,
    formData.associate_partner,
  ]);

  const handleInputChange = (e, index) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      if (updatedFormData.sectors !== "Road & Highway") {
        updatedFormData.lane_type = "0";
      }

      if (
        [
          "our_share_4_6_lane_length",
          "our_share_2_lane_length",
          "our_share_percent",
          "our_length_share_km",
          "our_cost_share_cr",
          "total_cost_cr",
          "total_length_km",
        ].includes(name)
      ) {
        const total_cost_cr = parseFloat(
          updatedFormData.total_cost_cr || 0,
        ).toFixed(2);
        const our_share_percent = parseFloat(
          updatedFormData.our_share_percent || 0,
        ).toFixed(2);
        const total_length_km = parseFloat(
          updatedFormData.total_length_km || 0,
        ).toFixed(2);

        if (
          updatedFormData.lane_type === "2" &&
          updatedFormData.total_cost_cr > 1
        ) {
          updatedFormData.our_share_4_6_lane_length = (
            total_length_km *
            0.4 *
            (our_share_percent / 100)
          ).toFixed(2);
        } else {
          updatedFormData.our_share_4_6_lane_length = "0";
        }
        if (
          updatedFormData.lane_type === "4" ||
          updatedFormData.lane_type === "6"
        ) {
          updatedFormData.our_share_2_lane_length = (
            total_length_km *
            1.5 *
            (our_share_percent / 100)
          ).toFixed(2);
        } else {
          updatedFormData.our_share_2_lane_length = "0";
        }
        updatedFormData.our_length_share_km = (
          total_length_km *
          (our_share_percent / 100)
        ).toFixed(2);
        updatedFormData.our_cost_share_cr = (
          total_cost_cr *
          (our_share_percent / 100)
        ).toFixed(2);
      }

      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value.trim()) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project !== "null") {
      getProjectbyID();
    }
  }, [formData.project]);

  const getStructure = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/structuredetail/`);
      setstructureList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value,
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (name === "document_name" && value.trim()) {
          delete updatedErrors[`document_name_${index}`];
        }
        if (name === "document_file" && files?.[0]) {
          delete updatedErrors[`document_file_${index}`];
        }
        return updatedErrors;
      });

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index),
    );
  };

  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [buffer, setBuffering] = useState(true);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "structure_details") {
              formData[key].forEach((value) =>
                formDataToSend.append(key, value),
              );
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });

        formData.documents.forEach((doc, index) => {
          if (doc.document_file) {
            const customFile = createCustomFile(doc.document_file);
            formDataToSend.append(
              `documents[${index}][document_name]`,
              doc.document_name,
            );
            formDataToSend.append(
              `documents[${index}][document_file]`,
              customFile,
            );
          }
        });

        const res = await axiosInstance2.post(
          `/siteproject/docs-Bulkwith-Certifications/`,
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          },
        );

        if (res.status === 201) {
          handleClose();
          await getcertification();
          toast.success("Data submitted successfully!");
        } else {
          throw new Error("Document upload failed");
        }
      } catch (err) {
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };
  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join("");
  };

  const options = structureList.map((e) => ({
    value: e.id,
    label: e.name,
  }));

  const handleChangecc = (selected) => {
    const structure_details =
      selected.length > 0 ? selected.map((item) => item.value) : [];
    setFormData((prevState) => ({
      ...prevState,
      structure_details,
    }));
  };

  return (
    <>
      <button title="Add Certificate" className="ca_btn" onClick={handleShow}>
        <AddwithWhiteCircle /> Certification
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Certification Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ca_modal-section-title">Required Information</div>
          <div className="ca_form-grid">
            <div className="ca_form-field" title="Site Sub Company">
              <label htmlFor="company_name" className="ca_form-label">
                Site Sub Company
              </label>
              <select
                id="company_name"
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                className={`ca_select ${errors.company_name
                  ? "ca_select--error"
                  : inputState.company_name
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Site SubCompany</option>
                {siteSubCompanyList
                  ?.sort((a, b) =>
                    a.title.localeCompare(b.title, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.title}
                    </option>
                  ))}
              </select>
              {errors.company_name && (
                <span className="ca_error-message">
                  {errors.company_name}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="Project">
              <label htmlFor="project" className="ca_form-label">
                Project
              </label>
              <select
                id="project"
                name="project"
                value={formData.project}
                onChange={handleInputChange}
                className={`ca_select ${errors.project
                  ? "ca_select--error"
                  : inputState.project
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select Project</option>
                {projectList
                  ?.sort((a, b) =>
                    a.site_prcode.localeCompare(b.site_prcode, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.site_prcode}-{i.project_short_name}
                    </option>
                  ))}
              </select>
              {errors.project && (
                <span className="ca_error-message">{errors.project}</span>
              )}
            </div>

            <div className="ca_form-field" title="project_short_name">
              <label htmlFor="project_short_name" className="ca_form-label">
                Project Short Name
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_short_name"
                name="project_short_name"
                placeholder="Project Short Name"
                onChange={handleInputChange}
                value={formData.project_short_name}
                className={`ca_input ${errors.project_short_name
                  ? "ca_input--error"
                  : inputState.project_short_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_short_name && (
                <span className="ca_error-message">
                  {errors.project_short_name}
                </span>
              )}
            </div>

            <div className="ca_form-field ca_form-field--full" title="project_full_name">
              <label htmlFor="project_full_name" className="ca_form-label">
                Project Full Name
              </label>
              <textarea
                id="project_full_name"
                name="project_full_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_full_name}
                className={`ca_textarea ${errors.project_full_name
                  ? "ca_input--error"
                  : inputState.project_full_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_full_name && (
                <span className="ca_error-message">
                  {errors.project_full_name}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="service_type">
              <label htmlFor="service_type" className="ca_form-label">
                Service Type
              </label>
              <select
                id="service_type"
                name="service_type"
                value={formData.service_type}
                onChange={handleInputChange}
                className={`ca_select ${errors.service_type
                  ? "ca_select--error"
                  : inputState.service_type
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Service Type</option>
                <option value="DPR">DPR</option>
                <option value="AE">AE</option>
                <option value="IE">IE</option>
                <option value="O&M">O&M</option>
                <option value="Safety">Safety</option>
              </select>
              {errors.service_type && (
                <span className="ca_error-message">
                  {errors.service_type}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="sectors">
              <label htmlFor="sectors" className="ca_form-label">
                Sector Type
              </label>
              <select
                id="sectors"
                name="sectors"
                value={formData.sectors}
                onChange={handleInputChange}
                className={`ca_select ${errors.sectors
                  ? "ca_select--error"
                  : inputState.sectors
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Service Type</option>
                <option value="Railway">Railway</option>
                <option value="Road & Highway">Road & Highway</option>
                <option value="Water">Water</option>
                <option value="Metro">Metro</option>
              </select>
              {errors.sectors && (
                <span className="ca_error-message">{errors.sectors}</span>
              )}
            </div>

            <div className="ca_form-field" title="client">
              <label htmlFor="client" className="ca_form-label">
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`ca_input ${errors.client
                  ? "ca_input--error"
                  : inputState.client
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.client && (
                <span className="ca_error-message">{errors.client}</span>
              )}
            </div>

            <div className="ca_form-field" title="Start Date">
              <label htmlFor="start_date" className="ca_form-label">
                Start Date<span className="ca_required">*</span>
              </label>
              <input
                type="date"
                id="start_date"
                name="start_date"
                onChange={handleInputChange}
                value={formData.start_date}
                className={`ca_input ${errors.start_date
                  ? "ca_input--error"
                  : inputState.start_date
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.start_date && (
                <span className="ca_error-message">{errors.start_date}</span>
              )}
            </div>
          </div>

          <div className="ca_disclosure">
            <button
              type="button"
              className="ca_disclosure-toggle"
            >
              Additional Details (Optional)
              {/* <span
                className={`ca_expand-arrow ${showMoreDetails ? "ca_expand-arrow--open" : ""
                  }`}
              >
                ▼
              </span> */}
            </button>
            <div className="ca_disclosure-body">
              <div className="ca_form-grid">
                <div className="ca_form-field ca_form-field--full">
                  <label htmlFor="structure_details" className="ca_form-label">
                    Structure Type
                  </label>
                  <Select
                    options={options}
                    isMulti
                    onChange={handleChangecc}
                    styles={caSelectStyles}
                  />
                  {errors.structure_details && (
                    <span className="ca_error-message">
                      {errors.structure_details}
                    </span>
                  )}
                </div>

                {formData.sectors === "Road & Highway" && (
                  <div className="ca_form-field" title="Lane Type">
                    <label htmlFor="lane_type" className="ca_form-label">
                      Lane Type
                    </label>
                    <select
                      id="lane_type"
                      name="lane_type"
                      value={formData.lane_type}
                      onChange={handleInputChange}
                      className={`ca_select ${errors.lane_type
                        ? "ca_select--error"
                        : inputState.lane_type
                          ? "ca_select--success"
                          : ""
                        }`}
                    >
                      <option value="0">Select a Lane Type</option>
                      <option value="2">2 Lane</option>
                      <option value="4">4 Lane</option>
                      <option value="6">6 Lane</option>
                    </select>
                    {errors.lane_type && (
                      <span className="ca_error-message">
                        {errors.lane_type}
                      </span>
                    )}
                  </div>
                )}

                <div className="ca_form-field" title="total_length_km">
                  <label htmlFor="total_length_km" className="ca_form-label">
                    Total Length (KM)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="total_length_km"
                    name="total_length_km"
                    placeholder="Total Length"
                    onChange={handleInputChange}
                    value={formData.total_length_km}
                    className={`ca_input ${errors.total_length_km
                      ? "ca_input--error"
                      : inputState.total_length_km
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_length_km && (
                    <span className="ca_error-message">
                      {errors.total_length_km}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="project_cost">
                  <label htmlFor="project_cost" className="ca_form-label">
                    Project Cost (in Cr.)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="project_cost"
                    name="project_cost"
                    placeholder="Total Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost}
                    className={`ca_input ${errors.project_cost
                      ? "ca_input--error"
                      : inputState.project_cost
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_cost && (
                    <span className="ca_error-message">
                      {errors.project_cost}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="total_cost_cr">
                  <label htmlFor="total_cost_cr" className="ca_form-label">
                    Total Cost (in Cr.)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="total_cost_cr"
                    name="total_cost_cr"
                    placeholder="Total Cost"
                    onChange={handleInputChange}
                    value={formData.total_cost_cr}
                    className={`ca_input ${errors.total_cost_cr
                      ? "ca_input--error"
                      : inputState.total_cost_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_cost_cr && (
                    <span className="ca_error-message">
                      {errors.total_cost_cr}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="End Date">
                  <label htmlFor="end_date" className="ca_form-label">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    min={formData.start_date}
                    onChange={handleInputChange}
                    value={formData.end_date}
                    className={`ca_input ${errors.end_date
                      ? "ca_input--error"
                      : inputState.end_date
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.end_date && (
                    <span className="ca_error-message">
                      {errors.end_date}
                    </span>
                  )}
                </div>

                <div className="ca_form-field ca_form-field--full" title="jv_partner">
                  <div className="ca_toggle-row">
                    <label htmlFor="jv_partner" className="ca_form-label">
                      JV Partner
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="toggle1"
                        name="is_jv"
                        type="checkbox"
                        value={formData.is_jv}
                        onChange={handleInputChange}
                        checked={formData.is_jv}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  <input
                    type="text"
                    maxLength={100}
                    id="jv_partner"
                    name="jv_partner"
                    placeholder="JV Partner "
                    onChange={handleInputChange}
                    value={formData.jv_partner}
                    className={`ca_input ${errors.jv_partner
                      ? "ca_input--error"
                      : inputState.jv_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.jv_partner && (
                    <span className="ca_error-message">
                      {errors.jv_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="lead_partner">
                  <label htmlFor="lead_partner" className="ca_form-label">
                    Lead Partner
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="lead_partner"
                    name="lead_partner"
                    placeholder="Lead Partner"
                    onChange={handleInputChange}
                    value={formData.lead_partner}
                    className={`ca_input ${errors.lead_partner
                      ? "ca_input--error"
                      : inputState.lead_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.lead_partner && (
                    <span className="ca_error-message">
                      {errors.lead_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="associate_partner">
                  <label htmlFor="associate_partner" className="ca_form-label">
                    Associate Partner
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="associate_partner"
                    name="associate_partner"
                    placeholder="Associate Partner"
                    onChange={handleInputChange}
                    value={formData.associate_partner}
                    className={`ca_input ${errors.associate_partner
                      ? "ca_input--error"
                      : inputState.associate_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.associate_partner && (
                    <span className="ca_error-message">
                      {errors.associate_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="our_share_percent">
                  <label htmlFor="our_share_percent" className="ca_form-label">
                    Our Share Percent
                  </label>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    id="our_share_percent"
                    name="our_share_percent"
                    placeholder="Our Share Percent"
                    onChange={handleInputChange}
                    value={formData.our_share_percent}
                    className={`ca_input ${errors.our_share_percent
                      ? "ca_input--error"
                      : inputState.our_share_percent
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.our_share_percent && (
                    <span className="ca_error-message">
                      {errors.our_share_percent}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="our_length_share_km">
                  <label htmlFor="our_length_share_km" className="ca_form-label">
                    Our Share Length KM
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_length_share_km"
                    name="our_length_share_km"
                    placeholder="Our Share Length KM"
                    onChange={handleInputChange}
                    value={formData.our_length_share_km}
                    readOnly
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_cost_share_cr">
                  <label htmlFor="our_cost_share_cr" className="ca_form-label">
                    Our Cost Share (in crores)
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_cost_share_cr"
                    name="our_cost_share_cr"
                    placeholder="Our Cost Share "
                    onChange={handleInputChange}
                    value={formData.our_cost_share_cr}
                    readOnly
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_share_4_6_lane_length">
                  <label htmlFor="our_share_4_6_lane_length" className="ca_form-label">
                    Our Share 4-6 Lane Length
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_share_4_6_lane_length"
                    name="our_share_4_6_lane_length"
                    placeholder="Our Share 4-6 lane length "
                    onChange={handleInputChange}
                    readOnly
                    value={formData.our_share_4_6_lane_length}
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_share_2_lane_length">
                  <label htmlFor="our_share_2_lane_length" className="ca_form-label">
                    Our Share 2 Lane Length
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_share_2_lane_length"
                    name="our_share_2_lane_length"
                    placeholder="Our Share 2 Lane Length "
                    readOnly
                    onChange={handleInputChange}
                    value={formData.our_share_2_lane_length}
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field ca_form-field--full" title="remarks">
                  <label htmlFor="remarks" className="ca_form-label">
                    Remarks
                  </label>
                  <input
                    type="text"
                    id="remarks"
                    name="remarks"
                    placeholder="Remarks "
                    onChange={handleInputChange}
                    value={formData.remarks}
                    className={`ca_input ${errors.remarks
                      ? "ca_input--error"
                      : inputState.remarks
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.remarks && (
                    <span className="ca_error-message">{errors.remarks}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <DocumentSection
            formData={formData}
            handleDocInputChange={handleDocInputChange}
            handleAddDocuments={handleAddDocuments}
            handleRemoveDocument={handleRemoveDocument}
            errors={errors}
            fileNames={fileNames}
            inputState={inputState}
          />

          {uploadProgress > 0 && (
            <div className="ca_progress-wrap">
              <div className="ca_progress-label">
                Uploading {uploadProgress}%
              </div>
              <div className="ca_progress-track">
                <div
                  className="ca_progress-fill"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
            </div>
          )}

          <div className="ca_modal-footer">
            <button
              onClick={handleFormSubmit}
              className="ca_btn"
              disabled={loading}
              type="button"
            >
              Submit
            </button>
          </div>
          {isSubmitted && Object.keys(errors).length > 0 && (
            <p className="ca_form-error-summary">
              {Object.keys(errors).length > 5
                ? "Please fill all mandatory fields!"
                : Object.keys(errors)
                  .map(
                    (field) =>
                      field.charAt(0).toUpperCase() + field.slice(1),
                  )
                  .join(", ") + " are required!"}
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateCertificate = ({
  i,
  title,
  projectId,
  letterType,
  workperformedby,
  associatedletters,
  getcertification,
}) => {
  const [projectbyId, setProjectbyID] = useState();
  const [show, setShow] = useState(false);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [structureList, setstructureList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormData(i);
    getStructure();
  };

  function initialFormData() {
    return {
      company_name: "",
      service_type: "",
      project_short_name: "",
      project_full_name: "",
      structure_details: "",
      client: "",
      lane_type: "",
      project: "null",
      total_length_km: "",
      total_cost_cr: "",
      is_jv: false,
      lead_partner: "",
      sectors: "",
      project_cost: "",
      jv_partner: "",
      associate_partner: "",
      our_share_percent: "",
      our_length_share_km: "0",
      our_cost_share_cr: "0",
      our_share_4_6_lane_length: "0",
      our_share_2_lane_length: "0",
      start_date: null,
      end_date: null,
      remarks: "",
      documents: [{ document_name: "", document_file: "" }],
    };
  }

  const [formData, setFormData] = useState({
    project: "",
    company_name: "",
    service_type: "",
    project_short_name: "",
    project_full_name: "",
    structure_details: [],
    client: "",
    lane_type: "0",
    total_length_km: "",
    total_cost_cr: "",
    is_jv: false,
    lead_partner: "",
    sectors: "",
    project_cost: "",
    jv_partner: "",
    associate_partner: "",
    our_share_percent: "",
    our_length_share_km: "",
    our_cost_share_cr: "",
    our_share_4_6_lane_length: "",
    our_share_2_lane_length: "",
    start_date: null,
    end_date: null,
    remarks: "",
    documents: [{ document_name: "", document_file: "" }],
  });

  const [formDataDoc, setFormDataDoc] = useState({
    documents: [
      {
        document_name: null,
        document_file: "",
      },
    ],
  });
  const getStructure = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/structuredetail/`);
      setstructureList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
      return acc;
    }, {});

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const getProjects = async () => {
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.company_name ? formData.company_name : "null"}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };
  useEffect(() => {
    if (formData.company_name) {
      getProjects();
    }
  }, [formData.company_name]);

  const handleInputChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      if (updatedFormData.sectors !== "Road & Highway") {
        updatedFormData.lane_type = "";
      }

      if (
        [
          "our_share_4_6_lane_length",
          "our_share_2_lane_length",
          "our_share_percent",
          "our_length_share_km",
          "our_cost_share_cr",
          "total_cost_cr",
          "total_length_km",
        ].includes(name)
      ) {
        const total_cost_cr = parseFloat(
          updatedFormData.total_cost_cr || 0,
        ).toFixed(2);
        const our_share_percent = parseFloat(
          updatedFormData.our_share_percent || 0,
        ).toFixed(2);
        const total_length_km = parseFloat(
          updatedFormData.total_length_km || 0,
        ).toFixed(2);

        if (
          updatedFormData.lane_type === "2" &&
          updatedFormData.total_cost_cr > 1
        ) {
          updatedFormData.our_share_4_6_lane_length = (
            total_length_km *
            0.4 *
            (our_share_percent / 100)
          ).toFixed(2);
        } else {
          updatedFormData.our_share_4_6_lane_length = 0;
        }
        updatedFormData.our_share_2_lane_length = (
          total_length_km *
          1.5 *
          (our_share_percent / 100)
        ).toFixed(2);
        updatedFormData.our_length_share_km = (
          total_length_km *
          (our_share_percent / 100)
        ).toFixed(2);
        updatedFormData.our_cost_share_cr = (
          total_cost_cr *
          (our_share_percent / 100)
        ).toFixed(2);
      }

      return updatedFormData;
    });
  };

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project) getProjectbyID();
  }, [formData.project]);

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };
  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join("");
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "structure_details") {
              formData[key].forEach((value) =>
                formDataToSend.append(key, value),
              );
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });
        formData.documents.forEach((doc, index) => {
          if (doc.document_file) {
            const customFile = createCustomFile(doc.document_file);
            formDataToSend.append(
              `documents[${index}][document_name]`,
              doc.document_name,
            );
            formDataToSend.append(
              `documents[${index}][document_file]`,
              customFile,
            );
          }
        });

        let res = await axios.put(
          `${BASE_URL}/siteproject/docs-Bulk-with-Certifications-update/${i.id}/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200) {
          handleClose();
          await getcertification();
          toast.success("Data submitted successfully!");
        } else {
          throw new Error("Document upload failed");
        }
      } catch (err) {
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const options = structureList.map((e) => ({
    value: e.id,
    label: e.name,
  }));

  const handleChangecc = (selected) => {
    const structure_details =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      structure_details,
    }));
  };
  const [fileNames, setFileNames] = useState([]);

  const handleDocInputChange = (index, e) => {
    const { name, value, type, files } = e.target;

    setFormDataDoc((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      if (type === "file") {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: files[0],
        };
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name;
          return newFileNames;
        });
      } else {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: value.trim() ? value : "",
        };
      }
      return {
        ...prevFormData,
        documents: newDocuments,
      };
    });
  };

  const handleAddDocuments = (e) => {
    e.preventDefault();
    setFormDataDoc((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        {
          document_name: "",
          document_file: null,
        },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormDataDoc((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments.splice(index, 1);
      return {
        ...prevFormData,
        documents: newDocuments,
      };
    });
    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };

  const handlePicDelete = async (e, i, getProjects) => {
    e.preventDefault();

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/documents/${i.id}/`,
      );

      if (res.status === 200) {
        await getProjects();
        toast.success("Document deleted Successfully");
        toast.dismiss(loadingToastId);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button onClick={handleShow} className="ca_btn ca_btn--outline">
        View
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title ? title : "Update Track Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ca_modal-section-title">Required Information</div>
          <div className="ca_form-grid">
            <div className="ca_form-field" title="Site Sub Company">
              <label htmlFor="company_name" className="ca_form-label">
                Site Sub Company
              </label>
              <select
                id="company_name"
                name="company_name"
                value={formData.company_name}
                onChange={handleInputChange}
                className={`ca_select ${errors.company_name
                  ? "ca_select--error"
                  : inputState.company_name
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Site SubCompany</option>
                {siteSubCompanyList
                  ?.sort((a, b) =>
                    a.title.localeCompare(b.title, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.title}
                    </option>
                  ))}
              </select>
              {errors.company_name && (
                <span className="ca_error-message">
                  {errors.company_name}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="Project">
              <label htmlFor="project" className="ca_form-label">
                Project
              </label>
              <select
                id="project"
                name="project"
                value={formData.project}
                onChange={handleInputChange}
                className={`ca_select ${errors.project
                  ? "ca_select--error"
                  : inputState.project
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select Project</option>
                {projectList
                  ?.sort((a, b) =>
                    a.site_prcode.localeCompare(b.site_prcode, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.site_prcode}-{i.project_short_name}
                    </option>
                  ))}
              </select>
              {errors.project && (
                <span className="ca_error-message">{errors.project}</span>
              )}
            </div>

            <div className="ca_form-field" title="project_short_name">
              <label htmlFor="project_short_name" className="ca_form-label">
                Project Short Name
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_short_name"
                name="project_short_name"
                placeholder="Project Short Name"
                onChange={handleInputChange}
                value={formData.project_short_name}
                className={`ca_input ${errors.project_short_name
                  ? "ca_input--error"
                  : inputState.project_short_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_short_name && (
                <span className="ca_error-message">
                  {errors.project_short_name}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="project_full_name">
              <label htmlFor="project_full_name" className="ca_form-label">
                Project Full Name
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_full_name"
                name="project_full_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_full_name}
                className={`ca_input ${errors.project_full_name
                  ? "ca_input--error"
                  : inputState.project_full_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_full_name && (
                <span className="ca_error-message">
                  {errors.project_full_name}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="service_type">
              <label htmlFor="service_type" className="ca_form-label">
                Service Type
              </label>
              <select
                id="service_type"
                name="service_type"
                value={formData.service_type}
                onChange={handleInputChange}
                className={`ca_select ${errors.service_type
                  ? "ca_select--error"
                  : inputState.service_type
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Service Type</option>
                <option value="DPR">DPR</option>
                <option value="AE">AE</option>
                <option value="IE">IE</option>
                <option value="O&M">O&M</option>
                <option value="Safety">Safety</option>
              </select>
              {errors.service_type && (
                <span className="ca_error-message">
                  {errors.service_type}
                </span>
              )}
            </div>

            <div className="ca_form-field" title="sectors">
              <label htmlFor="sectors" className="ca_form-label">
                Sector Type
              </label>
              <select
                id="sectors"
                name="sectors"
                value={formData.sectors}
                onChange={handleInputChange}
                className={`ca_select ${errors.sectors
                  ? "ca_select--error"
                  : inputState.sectors
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="">Select a Service Type</option>
                <option value="Railway">Railway</option>
                <option value="Road & Highway">Road & Highway</option>
                <option value="Water">Water</option>
                <option value="Metro">Metro</option>
              </select>
              {errors.sectors && (
                <span className="ca_error-message">{errors.sectors}</span>
              )}
            </div>

            <div className="ca_form-field" title="client">
              <label htmlFor="client" className="ca_form-label">
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`ca_input ${errors.client
                  ? "ca_input--error"
                  : inputState.client
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.client && (
                <span className="ca_error-message">{errors.client}</span>
              )}
            </div>

            <div className="ca_form-field" title="Start Date">
              <label htmlFor="start_date" className="ca_form-label">
                Start Date<span className="ca_required">*</span>
              </label>
              <input
                type="date"
                id="start_date"
                name="start_date"
                onChange={handleInputChange}
                value={formData.start_date}
                className={`ca_input ${errors.start_date
                  ? "ca_input--error"
                  : inputState.start_date
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.start_date && (
                <span className="ca_error-message">{errors.start_date}</span>
              )}
            </div>
          </div>

          <div className="ca_disclosure">
            <button
              type="button"
              className="ca_disclosure-toggle"
            // onClick={() => setShowMoreDetails((p) => !p)}
            >
              Additional Details (Optional)
              {/* <span
                className={`ca_expand-arrow ${showMoreDetails ? "ca_expand-arrow--open" : ""
                  }`}
              >
                ▼
              </span> */}
            </button>
            {/* <div
              className={`ca_disclosure-body ${showMoreDetails ? "" : "ca_disclosure-body--closed"
                }`}
            > */}
            <div className="ca_disclosure-body">
              <div className="ca_form-grid">
                <div className="ca_form-field ca_form-field--full" title="Structure Type">
                  <label htmlFor="structure_details" className="ca_form-label">
                    Structure Type
                  </label>
                  <Select
                    options={options}
                    isMulti
                    placeholder="Select Structure Type"
                    onChange={handleChangecc}
                    styles={caSelectStyles}
                  />
                </div>

                {formData.sectors === "Road & Highway" && (
                  <div className="ca_form-field" title="Lane Type">
                    <label htmlFor="lane_type" className="ca_form-label">
                      Lane Type
                    </label>
                    <select
                      id="lane_type"
                      name="lane_type"
                      value={formData.lane_type}
                      onChange={handleInputChange}
                      className={`ca_select ${errors.lane_type
                        ? "ca_select--error"
                        : inputState.lane_type
                          ? "ca_select--success"
                          : ""
                        }`}
                    >
                      <option value="">Select a Lane Type</option>
                      <option value="2">2 Lane</option>
                      <option value="4">4 Lane</option>
                      <option value="6">6 Lane</option>
                    </select>
                    {errors.lane_type && (
                      <span className="ca_error-message">
                        {errors.lane_type}
                      </span>
                    )}
                  </div>
                )}

                <div className="ca_form-field" title="total_length_km">
                  <label htmlFor="total_length_km" className="ca_form-label">
                    Total Length (KM)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="total_length_km"
                    name="total_length_km"
                    placeholder="Total Length"
                    onChange={handleInputChange}
                    value={formData.total_length_km}
                    className={`ca_input ${errors.total_length_km
                      ? "ca_input--error"
                      : inputState.total_length_km
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_length_km && (
                    <span className="ca_error-message">
                      {errors.total_length_km}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="project_cost">
                  <label htmlFor="project_cost" className="ca_form-label">
                    Project Cost (in Cr.)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="project_cost"
                    name="project_cost"
                    placeholder="Total Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost}
                    className={`ca_input ${errors.project_cost
                      ? "ca_input--error"
                      : inputState.project_cost
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_cost && (
                    <span className="ca_error-message">
                      {errors.project_cost}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="total_cost_cr">
                  <label htmlFor="total_cost_cr" className="ca_form-label">
                    Total Cost (in Cr.)
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="total_cost_cr"
                    name="total_cost_cr"
                    placeholder="Total Cost"
                    onChange={handleInputChange}
                    value={formData.total_cost_cr}
                    className={`ca_input ${errors.total_cost_cr
                      ? "ca_input--error"
                      : inputState.total_cost_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_cost_cr && (
                    <span className="ca_error-message">
                      {errors.total_cost_cr}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="End Date">
                  <label htmlFor="end_date" className="ca_form-label">
                    End Date<span className="ca_required">*</span>
                  </label>
                  <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    min={formData.start_date}
                    onChange={handleInputChange}
                    value={formData.end_date}
                    className={`ca_input ${errors.end_date
                      ? "ca_input--error"
                      : inputState.end_date
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.end_date && (
                    <span className="ca_error-message">
                      {errors.end_date}
                    </span>
                  )}
                </div>

                <div className="ca_form-field ca_form-field--full" title="jv_partner">
                  <div className="ca_toggle-row">
                    <label htmlFor="jv_partner" className="ca_form-label">
                      JV Partner
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="toggle1"
                        name="is_jv"
                        type="checkbox"
                        value={formData.is_jv}
                        onChange={handleInputChange}
                        checked={formData.is_jv}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  <input
                    type="text"
                    maxLength={100}
                    id="jv_partner"
                    name="jv_partner"
                    placeholder="JV Partner "
                    onChange={handleInputChange}
                    value={formData.jv_partner}
                    className={`ca_input ${errors.jv_partner
                      ? "ca_input--error"
                      : inputState.jv_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.jv_partner && (
                    <span className="ca_error-message">
                      {errors.jv_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="lead_partner">
                  <label htmlFor="lead_partner" className="ca_form-label">
                    Lead Partner
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="lead_partner"
                    name="lead_partner"
                    placeholder="Lead Partner"
                    onChange={handleInputChange}
                    value={formData.lead_partner}
                    className={`ca_input ${errors.lead_partner
                      ? "ca_input--error"
                      : inputState.lead_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.lead_partner && (
                    <span className="ca_error-message">
                      {errors.lead_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="associate_partner">
                  <label htmlFor="associate_partner" className="ca_form-label">
                    Associate Partner
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="associate_partner"
                    name="associate_partner"
                    placeholder="Associate Partner"
                    onChange={handleInputChange}
                    value={formData.associate_partner}
                    className={`ca_input ${errors.associate_partner
                      ? "ca_input--error"
                      : inputState.associate_partner
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.associate_partner && (
                    <span className="ca_error-message">
                      {errors.associate_partner}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="our_share_percent">
                  <label htmlFor="our_share_percent" className="ca_form-label">
                    Our Share Percent
                  </label>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    id="our_share_percent"
                    name="our_share_percent"
                    placeholder="Our Share Percent"
                    onChange={handleInputChange}
                    value={formData.our_share_percent}
                    className={`ca_input ${errors.our_share_percent
                      ? "ca_input--error"
                      : inputState.our_share_percent
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.our_share_percent && (
                    <span className="ca_error-message">
                      {errors.our_share_percent}
                    </span>
                  )}
                </div>

                <div className="ca_form-field" title="our_length_share_km">
                  <label htmlFor="our_length_share_km" className="ca_form-label">
                    Our Share Length KM
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_length_share_km"
                    name="our_length_share_km"
                    placeholder="Our Share Length KM"
                    onChange={handleInputChange}
                    value={formData.our_length_share_km}
                    readOnly
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_cost_share_cr">
                  <label htmlFor="our_cost_share_cr" className="ca_form-label">
                    Our Cost Share (in crores)
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_cost_share_cr"
                    name="our_cost_share_cr"
                    placeholder="Our Cost Share "
                    onChange={handleInputChange}
                    value={formData.our_cost_share_cr}
                    readOnly
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_share_4_6_lane_length">
                  <label htmlFor="our_share_4_6_lane_length" className="ca_form-label">
                    Our Share 4-6 Lane Length
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_share_4_6_lane_length"
                    name="our_share_4_6_lane_length"
                    placeholder="Our Share 4-6 lane length "
                    onChange={handleInputChange}
                    readOnly
                    value={formData.our_share_4_6_lane_length}
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field" title="our_share_2_lane_length">
                  <label htmlFor="our_share_2_lane_length" className="ca_form-label">
                    Our Share 2 Lane Length
                    <span className="ca_readonly-tag">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="our_share_2_lane_length"
                    name="our_share_2_lane_length"
                    placeholder="Our Share 2 Lane Length "
                    readOnly
                    onChange={handleInputChange}
                    value={formData.our_share_2_lane_length}
                    className="ca_input"
                  />
                </div>

                <div className="ca_form-field ca_form-field--full" title="remarks">
                  <label htmlFor="remarks" className="ca_form-label">
                    Remarks
                  </label>
                  <input
                    type="text"
                    id="remarks"
                    name="remarks"
                    placeholder="Remarks "
                    onChange={handleInputChange}
                    value={formData.remarks}
                    className={`ca_input ${errors.remarks
                      ? "ca_input--error"
                      : inputState.remarks
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.remarks && (
                    <span className="ca_error-message">{errors.remarks}</span>
                  )}
                </div>
              </div>

              <div className="ca_modal-section-title" style={{ marginTop: "16px" }}>
                Documents
                <button
                  title="Add Documents"
                  onClick={handleAddDocuments}
                  className="ca_btn--icon"
                  style={{ float: "right" }}
                >
                  +
                </button>
              </div>

              <table className="ca_table" style={{ minWidth: "auto" }}>
                <thead>
                  <tr>
                    <th className="ca_th">S. No.</th>
                    <th className="ca_th ca_th--center">Name</th>
                    <th className="ca_th ca_th--center">File</th>
                    <th className="ca_th ca_th--right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData?.documents?.map((doc, index) => (
                    <tr className="ca_row" key={index}>
                      <td className="ca_td">{index + 1}</td>
                      <td className="ca_td ca_td--center">
                        {doc.document_name}
                      </td>
                      <td className="ca_td ca_td--center">
                        {doc.document_file ? (
                          <a
                            href={doc.document_file}
                            target="blank"
                            className="ca_doc-link"
                          >
                            <DocumentIcon />
                          </a>
                        ) : (
                          <span className="ca_doc-nofile">
                            Document Not Attached
                          </span>
                        )}
                      </td>
                      <td className="ca_td ca_td--right">
                        <button
                          className="ca_btn--icon ca_btn--icon-danger"
                          onClick={(e) =>
                            handlePicDelete(e, doc, getcertification)
                          }
                        >
                          <DeleteDustbin />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="ca_doc-list" style={{ marginTop: "10px" }}>
                {formDataDoc?.documents?.map((doc, index) => (
                  <div key={index} className="ca_doc-form-row">
                    <div className="ca_form-field">
                      <label
                        htmlFor={`document_name_${index}`}
                        className="ca_form-label"
                      >
                        File Name
                      </label>
                      <input
                        type="text"
                        id={`document_name_${index}`}
                        name={`document_name`}
                        placeholder="Document Name"
                        value={doc.document_name}
                        onChange={(e) => handleDocInputChange(index, e)}
                        className={`ca_input ${errors[`document_name_${index}`]
                          ? "ca_input--error"
                          : inputState[`document_name`]
                            ? "ca_input--success"
                            : ""
                          }`}
                      />
                      {errors[`document_name_${index}`] && (
                        <span className="ca_error-message">
                          {errors[`document_name_${index}`]}
                        </span>
                      )}
                    </div>

                    <div className="ca_form-field">
                      <label className="ca_form-label">Upload File</label>
                      <label
                        htmlFor={`document_file_${index}`}
                        className="ca_doc-upload-label"
                      >
                        <Attachment />
                      </label>
                      <input
                        id={`document_file_${index}`}
                        name={`document_file`}
                        type="file"
                        onChange={(e) => handleDocInputChange(index, e)}
                        style={{ display: "none" }}
                      />
                      {fileNames[index] && (
                        <p className="ca_doc-filename">{fileNames[index]}</p>
                      )}
                      {errors[`document_file_${index}`] && (
                        <span className="ca_error-message">
                          {errors[`document_file_${index}`]}
                        </span>
                      )}
                    </div>

                    {index !== 0 && (
                      <button
                        type="button"
                        className="ca_btn ca_btn--cancel"
                        onClick={() => handleRemoveDocument(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <div className="ca_modal-footer">
                <button
                  onClick={handleFormSubmit}
                  className="ca_btn"
                  disabled={loading}
                >
                  Update
                </button>
              </div>
            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteCertificate = ({ i, getcertification }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/certifications/${i.id}/`,
      );

      if (res.status === 200) {
        await getcertification();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Insurance"
        className="ca_btn--icon ca_btn--icon-danger"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete Certificate of {i.project_short_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are You Sure You Want to delete Certificate of{" "}
            {i.project_short_name}
            <div className="ca_modal-footer">
              <button className="ca_btn ca_btn--cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="ca_btn ca_btn--danger"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Certificates = ({ projectId, letterBy, contractor, contractorlist }) => {
  const tableRef = useRef(null);
  const [toggleCompany, setToggleCompany] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

  const [workperformedby, setWorkperformedby] = useState("null");

  const [lettertype, setLetterType] = useState("null");
  const [structureList, setstructureList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState(null);

  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState("null");
  const [selectedToDate, setToDate] = useState("null");
  const [structure, setStructure] = useState("null");
  const [sector, setSector] = useState("null");
  const [service, setService] = useState("null");
  const [selectedProject, setSelectedProject] = useState("null");

  const [trackRecordList, setTrackRecordList] = useState([]);

  const [buffer, setBuffering] = useState(true);

  const [expandedRows, setExpandedRows] = useState({});
  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getcompany = async () => {
    setBuffering(true);
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  const getStructure = async () => {
    try {
      const getStr = await axios.get(
        `${BASE_URL}/siteproject/structuredetail/`,
      );
      setstructureList(getStr.data);
    } catch (error) {
      console.error(error);
    }
  };
  const [projectList, setProjectList] = useState([]);

  const getProject = async () => {
    setBuffering(true);
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${toggleCompany}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };
  const getProjects = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/certificationsfilter/${sector}/${structure}/${selectedProject}/${toggleCompany}/${selectedFromDate}/${selectedToDate}/${service}/`,
      );
      setTrackRecordList(res.data);
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getcompany();
    getStructure();
  }, []);
  useEffect(() => {
    getProject();
  }, [toggleCompany]);

  useEffect(() => {
    getProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sector,
    selectedFromDate,
    selectedToDate,
    structure,
    selectedProject,
    toggleCompany,
  ]);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNo, trackRecordList]);

  const applyFilters = () => {
    let filteredData = trackRecordList;
    if (selectedNo !== "") {
      const lowercaseSelectedName = selectedNo.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const lid = employee.letter_num
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return lid;
      });
    }

    setFilteredData(filteredData);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="ca_header">
        <div className="ca_header-title">Certifications</div>
        <div className="ca_header-actions">
          <DownloadAndZip
            projectData={trackRecordList}
            sector={sector}
            structure={structure}
            fromDate={selectedFromDate}
            toDate={selectedToDate}
            selectedProject={selectedProject}
            toggleCompany={toggleCompany}
          />
          <AddCertificationAccess
            getcertification={getProjects}
            projectList={projectList}
            siteSubCompanyList={siteSubCompanyList}
            toggleCompany={toggleCompany}
          />
        </div>
      </div>

      <div className="ca_filterbar">
        <div className="ca_filter-field">
          <label className="ca_filter-label">Sub Company</label>
          <select
            onChange={(e) => setToggleCompany(e.target.value)}
            value={toggleCompany}
            className="ca_filter-select"
          >
            <option value="null">Sub Company</option>
            {siteSubCompanyList.map((company, idx) => (
              <option value={company.id} key={idx}>
                {company.title}
              </option>
            ))}
          </select>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Project</label>
          <select
            onChange={(e) => setSelectedProject(e.target.value)}
            value={selectedProject}
            className="ca_filter-select"
          >
            <option value="null">Select Project</option>
            {projectList.map((project, idx) => (
              <option value={project.id} key={idx}>
                {project.site_prcode}-{project.project_short_name}
              </option>
            ))}
          </select>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Sector</label>
          <select
            id="sector"
            name="sector"
            value={sector}
            onChange={(e) => setSector(e.target.value)}
            className="ca_filter-select"
          >
            <option value="null">Sector Type</option>
            <option value="Railway">Railway</option>
            <option value="Road & Highway">Road & Highway</option>
            <option value="Water">Water</option>
            <option value="Metro">Metro</option>
          </select>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Structure</label>
          <select
            onChange={(e) => setStructure(e.target.value)}
            value={structure}
            className="ca_filter-select"
          >
            <option value="null">Select Structure Type</option>
            {structureList.map((str, idx) => (
              <option value={str.id} key={idx}>
                {str.name}
              </option>
            ))}
          </select>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Date Range</label>
          <div className="ca_filter-daterange">
            <DateRangePicker
              startDate={selectedFromDate}
              endDate={selectedToDate}
              placeHolder1="From Date"
              placeHolder2="To Date"
              onChange={(start, end) => {
                setFromDate(start);
                setToDate(end);
              }}
            />
          </div>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Service</label>
          <select
            id="service"
            name="service"
            value={service}
            onChange={(e) => setService(e.target.value)}
            className="ca_filter-select"
          >
            <option value="null">Service Type</option>
            <option value="DPR">DPR</option>
            <option value="AE">AE</option>
            <option value="IE">IE</option>
            <option value="O&M">O&M</option>
            <option value="Safety">Safety</option>
          </select>
        </div>

        <div className="ca_filterbar-right">
          <span className="ca_filter-count">
            Showing <strong>{filteredData.length}</strong> of{" "}
            <strong>{trackRecordList.length}</strong>
          </span>
        </div>
      </div>

      <div className="ca_table-scroll">
        <table ref={tableRef} className="ca_table">
          <thead>
            <tr>
              <th className="ca_th">S.no.</th>
              <th className="ca_th">Service Type</th>
              <th className="ca_th">Project Short Name</th>
              <th className="ca_th">Project Full Name</th>
              <th className="ca_th">Client</th>
              <th className="ca_th">Start Date</th>
              <th className="ca_th">End Date</th>
              <th className="ca_th ca_th--center">Details</th>
              {sessionStorage.getItem("sitemanagement_role") === "BD" ? null : (
                <>
                  <th className="ca_th ca_th--center">View/Edit</th>
                  <th className="ca_th ca_th--center">Delete</th>
                </>
              )}
            </tr>
          </thead>
          {buffer ? (
            <tbody>
              <tr className="ca_spinner-row">
                <td colSpan={10}>Loading…</td>
              </tr>
            </tbody>
          ) : error ? (
            <tbody>
              <tr>
                <td colSpan={10} className="ca_empty-row">
                  Error fetching data: {error.message}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {filteredData.length === 0 && (
                <tr>
                  <td colSpan={10} className="ca_empty-row">
                    No certification records found.
                  </td>
                </tr>
              )}
              {filteredData.map((i, index) => (
                <React.Fragment key={index}>
                  <tr
                    className={`ca_row ${index % 2 === 1 ? "ca_row--even" : ""
                      } ${expandedRows[i.id] ? "ca_row--expanded" : ""}`}
                  >
                    <td className="ca_td">{index + 1}.</td>
                    <td className="ca_td">{i.service_type}</td>
                    <td className="ca_td">{i.project_short_name}</td>
                    <td className="ca_td ca_td--name">
                      {i.project_full_name}
                    </td>
                    <td className="ca_td">{i.client}</td>
                    <td className="ca_td">{i.start_date}</td>
                    <td className="ca_td">{i.end_date}</td>
                    <td className="ca_td ca_td--center">
                      <button
                        className="ca_expand-btn"
                        onClick={() => toggleExpand(i.id)}
                      >
                        {expandedRows[i.id] ? "Hide" : "More"}
                        <span
                          className={`ca_expand-arrow ${expandedRows[i.id] ? "ca_expand-arrow--open" : ""
                            }`}
                        >
                          ▼
                        </span>
                      </button>
                    </td>
                    {sessionStorage.getItem("sitemanagement_role") ===
                      "BD" ? null : (
                      <>
                        <td className="ca_td ca_td--center">
                          <UpdateCertificate
                            i={i}
                            getcertification={getProjects}
                          />
                        </td>
                        <td className="ca_td ca_td--center">
                          <DeleteCertificate
                            i={i}
                            getcertification={getProjects}
                          />
                        </td>
                      </>
                    )}
                  </tr>

                  {expandedRows[i.id] && (
                    <tr className="ca_expand-row">
                      <td
                        colSpan={
                          sessionStorage.getItem("sitemanagement_role") ===
                            "BD"
                            ? 8
                            : 10
                        }
                      >
                        <div className="ca_expand-body">
                          <div className="ca_detail-grid">
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Structure Details
                              </span>
                              <span className="ca_detail-value">
                                {Array.isArray(i.structure_details) &&
                                  i.structure_details.length > 0 ? (
                                  <table className="ca_structure-mini-table">
                                    <tbody>
                                      {i.structure_details.map(
                                        (s, sIndex) => (
                                          <tr key={sIndex}>
                                            <td>{sIndex + 1}.</td>
                                            <td>|</td>
                                            <td>{s.name}</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                ) : (
                                  "-"
                                )}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Lane Type
                              </span>
                              <span className="ca_detail-value">
                                {i.lane_type}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Total Length
                              </span>
                              <span className="ca_detail-value">
                                {i.total_length_km}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Total Cost
                              </span>
                              <span className="ca_detail-value">
                                {i.total_cost_cr}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Lead Partner
                              </span>
                              <span className="ca_detail-value">
                                {i.lead_partner}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                JV Partner
                              </span>
                              <span className="ca_detail-value">
                                {i.jv_partner}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Associate Partner
                              </span>
                              <span className="ca_detail-value">
                                {i.associate_partner}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Share Percent
                              </span>
                              <span className="ca_detail-value">
                                {i.our_share_percent}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Share Length
                              </span>
                              <span className="ca_detail-value">
                                {i.our_length_share_km}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                Share Cost
                              </span>
                              <span className="ca_detail-value">
                                {i.our_cost_share_cr}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                4/6 Lane Length (Our Share)
                              </span>
                              <span className="ca_detail-value">
                                {i.our_share_4_6_lane_length}
                              </span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">
                                2 Lane Length (Our Share)
                              </span>
                              <span className="ca_detail-value">
                                {i.our_share_2_lane_length}
                              </span>
                            </div>
                            <div className="ca_detail-field ca_detail-field--full">
                              <span className="ca_detail-label">
                                Remarks
                              </span>
                              <span className="ca_detail-value">
                                {i.remarks}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          )}
        </table>
      </div>

      <div className="ca_statusbar">
        <span>
          Showing <strong>{filteredData.length}</strong> of{" "}
          <strong>{trackRecordList.length}</strong> records
        </span>
      </div>
    </>
  );
};

const DownloadAndZip = ({
  projectData,
  fromDate,
  toDate,
  sector,
  structure,
  selectedProject,
  toggleCompany,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [show, setShow] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const getDocument = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/certificationsfilter/${sector}/${structure}/${selectedProject}/${toggleCompany}/${fromDate}/${toDate}/`,
      );
      setDocumentList(res.data);
    } catch (err) {
    }
  };

  useEffect(() => {
    getDocument();
  }, [fromDate, toDate, sector, structure]);

  const fetchAndZipFiles = async () => {
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");
    setError("");

    try {
      const apiResponse = documentList;
      const files = apiResponse.flatMap((project) => project.documents);

      if (files.length === 0) {
        setError("No documents found in the API response.");
        setLoading(false);
        return;
      }

      const zip = new JSZip();

      const filePromises = files.map(async (file) => {
        try {
          const fileResponse = await axios.get(file.document_file, {
            responseType: "blob",
          });
          const fileName = `${file.document_name}.pdf`;
          zip.file(fileName, fileResponse.data);
        } catch (err) {
          console.error(`Failed to download: ${file.document_name}`, err);
        }
      });

      await Promise.all(filePromises);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "documents.zip");

      handleClose();
      toast.dismiss(loadingToastId);
      toast.success("Documents downloaded successfully!");
    } catch (err) {
      console.error("Error fetching data or downloading files:", err);
      setError("Failed to process the request. Please try again.");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Download All Certificates"
        className="ca_btn ca_btn--outline"
        onClick={handleShow}
      >
        <DownloadIcon /> Upload/Download
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Download Certificates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table className="ca_table" style={{ minWidth: "auto" }}>
              <thead>
                <tr>
                  <th className="ca_th ca_th--center">Name</th>
                  <th className="ca_th ca_th--center">File</th>
                </tr>
              </thead>
              <tbody>
                {documentList.map((project, i) =>
                  project.documents?.map((doc, index) => (
                    <tr className="ca_row" key={`${i}-${index}`}>
                      <td className="ca_td ca_td--center">
                        {doc.document_name}
                      </td>
                      <td className="ca_td ca_td--center">
                        {doc.document_file ? (
                          <a
                            href={doc.document_file}
                            target="blank"
                            className="ca_doc-link"
                          >
                            <DocumentIcon />
                          </a>
                        ) : (
                          <span className="ca_doc-nofile">
                            Document Not Attached
                          </span>
                        )}
                      </td>
                    </tr>
                  )),
                )}
              </tbody>
            </table>
            <div className="ca_modal-footer">
              <button className="ca_btn ca_btn--cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={fetchAndZipFiles}
                disabled={loading}
                className="ca_btn"
              >
                {loading ? (
                  "Downloading..."
                ) : (
                  <>
                    <DownloadIcon /> Certificates
                  </>
                )}
              </button>
            </div>
            {error && (
              <p className="ca_error-message" style={{ textAlign: "center" }}>
                {error}
              </p>
            )}
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const AddStructureName = ({ getName }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setFormData({
      name: "",
    });
    setErrors({});
    setShow(false);
  };

  const [formData, setFormData] = useState({
    name: "",
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const [loading, setLoading] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true);
      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/structuredetail/`,
          formData,
        );

        if (res.status === 200) {
          handleClose();
          await getName();
          toast.dismiss(loadingToastId);
          toast.success("Name Added Successfully");
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title="Add Structure" className="ca_btn" onClick={handleShow}>
        <AddwithWhiteCircle /> Structure Name
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Structure Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ca_form-field">
            <label htmlFor="name" className="ca_form-label">
              Structure Name<span className="ca_required">*</span>
            </label>
            <input
              type="text"
              maxLength={50}
              id="name"
              title="Structure Name"
              name="name"
              placeholder="Structure Name"
              onChange={handleInputChange}
              value={formData.name}
              className={`ca_input ${errors.name
                ? "ca_input--error"
                : inputState.name
                  ? "ca_input--success"
                  : ""
                }`}
            />
            {errors.name && (
              <span className="ca_error-message">{errors.name}</span>
            )}
            <div className="ca_modal-footer">
              <button
                className="ca_btn ca_btn--cancel"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="ca_btn"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteSturctureName = ({ i, getName }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/structuredetail/${i.id}/`,
      );

      if (res.status === 200) {
        await getName();
        setShow(false);
        toast.dismiss(loadingToastId);
        toast.success("Name Deleted Successfully.");
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Insurance"
        className="ca_btn--icon ca_btn--icon-danger"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are You Sure You Want to Delete Data?
            <div className="ca_modal-footer">
              <button className="ca_btn ca_btn--cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="ca_btn ca_btn--danger"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const StructureDetails = ({ structureDetails, getStructure, buffer }) => {
  return (
    <>
      <div className="ca_table-scroll" style={{ minHeight: "66vh" }}>
        <table className="ca_table">
          <thead>
            <tr>
              <th className="ca_th ca_text-left">Sr.no</th>
              <th className="ca_th ca_th--center">Structure Name</th>
              <th className="ca_th ca_th--right">Action</th>
            </tr>
          </thead>
          {buffer ? (
            <tbody>
              <tr className="ca_spinner-row">
                <td colSpan={3}>Loading…</td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {structureDetails
                .sort((a, b) =>
                  a.name?.localeCompare(b.name, "en", {
                    ignorePunctuation: true,
                  }),
                )
                .map((i, index) => (
                  <tr className="ca_row" key={index}>
                    <td className="ca_td ca_text-left">{index + 1}</td>
                    <td className="ca_td ca_text-center">{i.name}</td>
                    <td className="ca_td ca_text-right">
                      <DeleteSturctureName getName={getStructure} i={i} />
                    </td>
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const CertficateAccess = () => {
  const siteRole = sessionStorage.getItem("sitemanagement_role");
  const [structure, setStructure] = useState([]);
  const [buffer, setBuffering] = useState(true);

  const getStructure = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/structuredetail/`);
      setStructure(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };
  const [toggleState, setToggleState] = useState(1);

  useEffect(() => {
    if (toggleState === 2) {
      getStructure();
    }
  }, [toggleState]);

  return (
    <div className="ca_root">
      <div className="ca_tabbar">
        <div className="ca_tabbar-left">
          <button
            className={`ca_tab ${toggleState === 1 ? "ca_tab--active" : ""}`}
            onClick={() => setToggleState(1)}
          >
            Certifications
          </button>
          <button
            className={`ca_tab ${toggleState === 2 ? "ca_tab--active" : ""}`}
            onClick={() => setToggleState(2)}
          >
            Structure Name
          </button>
          <button
            className={`ca_tab ${toggleState === 3 ? "ca_tab--active" : ""}`}
            onClick={() => setToggleState(3)}
          >
            Company Credentials
          </button>
        </div>
        {toggleState === 2 && (
          <div className="ca_tabbar-right">
            <AddStructureName getName={getStructure} />
          </div>
        )}
      </div>

      {toggleState === 1 ? <Certificates /> : null}
      {toggleState === 2 ? (
        <StructureDetails
          structureDetails={structure}
          getStructure={getStructure}
          buffer={buffer}
        />
      ) : null}
      {toggleState === 3 ? <CertificateFormat /> : null}
    </div>
  );
};

export default CertficateAccess;